import { Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { TicketViewComponent } from "./ticket-view/ticket-view.component";
import { SpeakerViewComponent } from "./speaker-view/speaker-view.component";
import { SpreadsheetViewComponent } from "./spreadsheet-view/spreadsheet-view.component";
import { ArchiveViewComponent } from "./archive-view/archive-view.component";
// import { canDeactivateGuard } from "./can-desactivate-guard";
import { ModeLectureComponent } from "./archive-view/mode-lecture/mode-lecture.component";
import { ModeReorderingComponent } from "./archive-view/mode-reordering/mode-reordering.component";
// import { passwordGuard } from "./auth-guard";

export const ROUTE_REORDERING = "/freeware/reordering";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "tickets", component: TicketViewComponent },
  { path: "speakers", component: SpeakerViewComponent },
  { path: "event-budget", component: SpreadsheetViewComponent },
  {
    path: "freeware",
    component: ArchiveViewComponent,
    // canActivate: [passwordGuard],
    // canDeactivate: [canDeactivateGuard],
    children: [
      { path: "lecture", component: ModeLectureComponent },
      { path: "reordering", component: ModeReorderingComponent },
      { path: "", redirectTo: "lecture", pathMatch: "full" },
    ],
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "**", redirectTo: "/login" },
];
